// extracted by css-extract-rspack-plugin
export default {"arrow":"arrow-eZXGCd","visible":"visible-ocGpJF","sortingArrows":"sortingArrows-uw4xWT"};